var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 25.5,
    height: 17.5,
    rx: 1.75,
    fill: "white",
    stroke: "#D4D4D5",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6206 5.05762H15.381V12.8327H10.6206V5.05762Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1111 8.9457C11.1105 8.19703 11.2803 7.45802 11.6074 6.78463C11.9346 6.11123 12.4107 5.52107 12.9996 5.05883C12.2702 4.48558 11.3942 4.12911 10.4718 4.03016C9.54935 3.93121 8.61769 4.09377 7.78328 4.49927C6.94886 4.90477 6.24537 5.53684 5.75319 6.32324C5.26101 7.10964 5 8.01865 5 8.94637C5 9.8741 5.26101 10.7831 5.75319 11.5695C6.24537 12.3559 6.94886 12.988 7.78328 13.3935C8.61769 13.799 9.54935 13.9615 10.4718 13.8626C11.3942 13.7636 12.2702 13.4072 12.9996 12.8339C12.4105 12.3715 11.9343 11.7812 11.6071 11.1075C11.2799 10.4339 11.1103 9.69458 11.1111 8.94567V8.9457Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 8.9457C20.9999 9.8735 20.7388 10.7826 20.2465 11.569C19.7542 12.3554 19.0506 12.9875 18.2161 13.3929C17.3816 13.7984 16.4498 13.9608 15.5274 13.8617C14.6049 13.7626 13.7289 13.406 12.9995 12.8326C13.5882 12.3699 14.0641 11.7796 14.3914 11.1061C14.7187 10.4327 14.8887 9.69375 14.8887 8.945C14.8887 8.19626 14.7187 7.4573 14.3914 6.78386C14.0641 6.11043 13.5882 5.52012 12.9995 5.05746C13.7289 4.48403 14.6049 4.12738 15.5274 4.02829C16.4499 3.92919 17.3816 4.09165 18.2161 4.49709C19.0507 4.90253 19.7543 5.53459 20.2465 6.32103C20.7388 7.10746 20.9999 8.01653 20.9999 8.94433V8.9457Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.683aba692396cff35d5f7206ee060a52.svg";
export { ForwardRef as ReactComponent };